import getValidator from 'helpers/validator/validator'
import { EMPTY, PASSWORD_LENGTH, PASSWORD_LETTER, PASSWORD_NUMBER, PASSWORD_MATCH, MESSAGES, RULES, PASSWORD_SPECIAL_CHARACTER } from 'helpers/validator/constants'
import { passwordDecorator, passwordAndConfPassDecorator } from './helpers'
import { RESET_PASSWORD_EMPTY } from './constants'


const passwordValidateDescription = {
  message: RESET_PASSWORD_EMPTY,
  type: EMPTY
}

export default getValidator({
  password: passwordValidateDescription,
  confirmPassword: passwordValidateDescription,
  hiddenField: [
    { type: PASSWORD_LENGTH },
    { type: PASSWORD_LETTER },
    { type: PASSWORD_NUMBER },
    { type: PASSWORD_SPECIAL_CHARACTER },
    { type: PASSWORD_MATCH, passValues: true, decorate: true, checkValidity: passwordAndConfPassDecorator }
  ]
})

export const rules = [
  { label: MESSAGES[PASSWORD_LENGTH], checkValidity: passwordDecorator(RULES[PASSWORD_LENGTH]) },
  { label: MESSAGES[PASSWORD_LETTER], checkValidity: passwordDecorator(RULES[PASSWORD_LETTER]) },
  { label: MESSAGES[PASSWORD_NUMBER], checkValidity: passwordDecorator(RULES[PASSWORD_NUMBER]) },
  { label: MESSAGES[PASSWORD_SPECIAL_CHARACTER], checkValidity: passwordDecorator(RULES[PASSWORD_SPECIAL_CHARACTER]) },
  { label: MESSAGES[PASSWORD_MATCH], checkValidity: passwordAndConfPassDecorator(RULES[PASSWORD_MATCH]) }
]
